/**
 * Tutoriales alineados con www/index.html -> sección "Videos Tutoriales".
 * Mismos títulos e IDs de YouTube que la landing.
 */
export const demos = [
  // Para Apoderados (panel-miembros en index.html)
  {
    id: "apoderados-recorrido-general",
    categoria: "apoderados",
    titulo: "Recorrido general Apoderado",
    descripcion: "Recorrido general Apoderado",
    videoUrl: "https://www.youtube.com/embed/9tlO9Oy6Xoo",
  },
  {
    id: "miembros-instalar-app",
    categoria: "apoderados",
    titulo: "Instalar app MiCentrum Android",
    descripcion: "Instalar app MiCentrum Android",
    videoUrl: "https://www.youtube.com/embed/wmWwjbapcGM",
  },
  {
    id: "miembros-primer-curso",
    categoria: "apoderados",
    titulo: "Crea tu primer curso",
    descripcion: "Crea tu primer curso",
    videoUrl: "https://www.youtube.com/embed/3qrG-QjxBnw",
  },
  {
    id: "miembros-registrar-pago",
    categoria: "apoderados",
    titulo: "Registrar un pago",
    descripcion: "Registrar un pago",
    videoUrl: "https://www.youtube.com/embed/IcreH6cvtEw",
  },
  {
    id: "miembros-ver-pagos-gastos-ingresos",
    categoria: "apoderados",
    titulo: "Ver tus pagos, gastos e ingresos",
    descripcion: "Ver tus pagos, gastos e ingresos",
    videoUrl: "https://www.youtube.com/embed/1QBXw4D8zJE",
  },
  {
    id: "miembros-ventas",
    categoria: "apoderados",
    titulo: "Ventas",
    descripcion: "Ventas",
    videoUrl: "https://www.youtube.com/embed/rsEW393Xhgw",
  },
  {
    id: "miembros-donaciones",
    categoria: "apoderados",
    titulo: "Donaciones",
    descripcion: "Donaciones",
    videoUrl: "https://www.youtube.com/embed/rv6RNnZ-2D8",
  },
  // Para Directivos (panel-directivos en index.html)
  {
    id: "directivos-recorrido-general-administracion",
    categoria: "directiva",
    titulo: "Recorrido general administración",
    descripcion: "Recorrido general administración",
    videoUrl: "https://www.youtube.com/embed/87mliQ26XHw",
  },
  {
    id: "directivos-gestionar-fondos-recaudacion",
    categoria: "directiva",
    titulo: "Gestionar fondos de recaudación",
    descripcion: "Gestionar fondos de recaudación",
    videoUrl: "https://www.youtube.com/embed/MxmhEhm8ZHo",
  },
  {
    id: "directivos-validar-pagos-fondo",
    categoria: "directiva",
    titulo: "Validar pagos a fondo",
    descripcion: "Validar pagos a fondo",
    videoUrl: "https://www.youtube.com/embed/5Vl5H4eyZM8",
  },
  {
    id: "directivos-link-invitacion",
    categoria: "directiva",
    titulo: "Link de invitación",
    descripcion: "Link de invitación",
    videoUrl: "https://www.youtube.com/embed/g6a2oPehWTk",
  },
  {
    id: "directivos-crear-fondo-colecta",
    categoria: "directiva",
    titulo: "Crear fondo colecta",
    descripcion: "Crear fondo colecta",
    videoUrl: "https://www.youtube.com/embed/EYHMM_9Bwjk",
  },
  {
    id: "directivos-crear-fondo-montos-iguales",
    categoria: "directiva",
    titulo: "Crear fondo con montos iguales",
    descripcion: "Crear fondo con montos iguales",
    videoUrl: "https://www.youtube.com/embed/jjvtCNULBZg",
  },
  {
    id: "directivos-crear-fondo-montos-distintos",
    categoria: "directiva",
    titulo: "Crear fondo con montos distintos",
    descripcion: "Crear fondo con montos distintos",
    videoUrl: "https://www.youtube.com/embed/R-uks3tSf04",
  },
  {
    id: "directivos-validar-pago",
    categoria: "directiva",
    titulo: "Validar pago",
    descripcion: "Validar pago",
    videoUrl: "https://www.youtube.com/embed/0kfSCB9raa8",
  },
  {
    id: "directivos-registrar-gasto",
    categoria: "directiva",
    titulo: "Registrar gasto",
    descripcion: "Registrar gasto",
    videoUrl: "https://www.youtube.com/embed/c-Tp28cWp0M",
  },
  {
    id: "directivos-registrar-ingreso-extra",
    categoria: "directiva",
    titulo: "Registrar ingreso extra",
    descripcion: "Registrar ingreso extra",
    videoUrl: "https://www.youtube.com/embed/-sIZ4pil8vs",
  },
  {
    id: "directivos-gestionar-ventas",
    categoria: "directiva",
    titulo: "Gestionar ventas",
    descripcion: "Gestionar ventas",
    videoUrl: "https://www.youtube.com/embed/YREia8p8EZg",
  },
  {
    id: "directivos-gestionar-donaciones",
    categoria: "directiva",
    titulo: "Gestionar donaciones",
    descripcion: "Gestionar donaciones",
    videoUrl: "https://www.youtube.com/embed/AU_egkS_IUI",
  },
];
